import { apiClient } from "./apiClient";

export type Config = {
  organizationName: string;
  appSignalApiKey?: string;
  disableRenterFields?: boolean;
};

export const configGateway = {
  async getConfig(): Promise<Config> {
    return await apiClient.get("/api/config");
  },
};
